import Modal from 'react-modal';
import * as S from './styles';
import { useRouter } from 'next/router';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { FormEvent, useState } from 'react';
import { toast } from 'react-toastify';

import { Auth } from 'aws-amplify';
import { ToastIcon } from '@/components/global/ToastIcon';
import { RiLockPasswordFill } from 'react-icons/ri';

type ForgotFormData = {
  password: string;
  confirmPassword: string;
};

type typeForm = 'code' | 'newPassword';

type ForgotPasswordModal = {
  onClose: () => void;
  email: string;
};

const PasswordFormValidation = yup.object().shape({
  password: yup
    .string()
    .required('Digite sua senha!')
    .min(8, 'A senha deve conter no mínimo 8 dígitos!')
    .matches(/[A-Z]/, 'A senha deve conter letras maiúsculas!')
    .matches(/[a-z]/, 'A senha deve conter letras minúsculas!')
    .matches(/[0-9]/, 'A senha deve conter números!')
    .matches(/\W/, 'A senha deve conter caracteres especiais!'),
  confirmPassword: yup
    .string()
    .min(8, 'Senha deve conter pelo menos 8 caracteres')
    .required('Por favor, informe a senha')
    .oneOf([yup.ref('password')], 'As senhas devem ser iguais!'),
});

export function ModalForgotPassword({ onClose, email }: ForgotPasswordModal) {
  const [code, setCode] = useState<string>('');
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [typeForm, setTypeForm] = useState<typeForm>('code');

  function handleSubmitCodeForm(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    setTypeForm('newPassword');
  }

  const router = useRouter();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<ForgotFormData>({
    resolver: yupResolver(PasswordFormValidation),
  });

  async function submit({ password }: ForgotFormData) {
    try {
      setIsLoading(true);

      await Auth.forgotPasswordSubmit(email, code, password);
      toast.success(<strong>Senha alterada com sucesso</strong>, {
        icon: <ToastIcon type="success" />,
      });
      router.push('/');
    } catch (err) {
      console.log(err);
      toast.error(<strong>Erro ao tentar atualzar senha</strong>, {
        icon: <ToastIcon type="error" />,
      });
      setIsLoading(false);
    }
  }

  return (
    <Modal
      isOpen={true}
      contentLabel="Login With Email"
      style={{
        content: {
          maxWidth: '450px',
          height: '400px',
          width: '100%',

          background: '#2C0E80',
          border: '1px solid #AEA0E8',
        },
      }}
    >
      {typeForm === 'code' && (
        <S.ModalForm onSubmit={handleSubmitCodeForm}>
          <S.CodeGroup>
            <strong>Enviamos um código para seu E-Mail</strong>
            <p>Digite o código a baixo:</p>

            <input
              maxLength={6}
              value={code}
              onChange={(event) => setCode(event.target.value)}
            />

            <S.ModalFormFooter>
              <button type="button" onClick={onClose}>
                Cancelar
              </button>
              {code.length === 6 && (
                <button type="submit" disabled={code.length < 6}>
                  Continuar
                </button>
              )}
            </S.ModalFormFooter>
          </S.CodeGroup>
        </S.ModalForm>
      )}
      {typeForm === 'newPassword' && (
        <S.PasswordForm onSubmit={handleSubmit(submit)}>
          <strong>Definir nova senha</strong>
          <div>
            <S.InputGroup>
              <RiLockPasswordFill size={30} color="#fff" />
              <input
                {...register('password')}
                type="password"
                disabled={isLoading}
                placeholder="Senha"
              />
            </S.InputGroup>
            {!!errors.password?.message && (
              <strong className="error">{errors.password.message}</strong>
            )}
          </div>
          <div>
            <S.InputGroup>
              <RiLockPasswordFill size={30} color="#fff" />
              <input
                {...register('confirmPassword')}
                type="password"
                disabled={isLoading}
                placeholder="Confirmar Senha"
              />
            </S.InputGroup>
            {!!errors.confirmPassword?.message && (
              <strong className="error">
                {errors.confirmPassword.message}
              </strong>
            )}
          </div>
          <S.ModalFormFooter>
            {!isLoading && (
              <button type="button" onClick={onClose}>
                Cancelar
              </button>
            )}
            <button type="submit" disabled={isLoading}>
              {isLoading ? 'Atualizando' : 'Continuar'}
            </button>
          </S.ModalFormFooter>
        </S.PasswordForm>
      )}
    </Modal>
  );
}
